export default __webpack_public_path__ + "static/media/profile 2.2f9bc26f.png";